/* global $ */

// SEO LINK
$('.a').on('click', function (e) {
    if (!$(this).hasClass('popin')) {
        var decodedString, redirect;
        decodedString = decodeURIComponent(escape(window.atob($(this).attr('data-href'))));

        if (window.location.href.indexOf('CAMPAIGN=NEWSITE') !== -1) {
            redirect = seo_redirectAddCampaign(decodedString, $(this));
            if (redirect) {
                decodedString = redirect;
            }
        }
        if ($(this).attr('target') === '_blank') {
            window.open(decodedString);
        } else {
            document.location.href = decodedString;
        }
        return false;
    }
});

function seo_redirectAddCampaign (decodedString, elmt) {
    if (typeof elmt.attr('class') === 'undefined' || elmt.attr('class').indexOf('popin') === -1) {
        var destUrl, split, redirUrl, boolRedirect;
        boolRedirect = true;
        destUrl = decodedString + '';
        destUrl = destUrl.replace('CAMPAIGN=NEWSITE', '');
        if (destUrl.charAt(destUrl.length - 1) === '?') {
            destUrl = destUrl.replace('?', '');
        }
        split = destUrl.split('#');
        if (typeof split[0] === 'string') {
            redirUrl = split[0] + '';
            if (redirUrl.indexOf('?') !== -1) {
                redirUrl = redirUrl.replace('?', '?CAMPAIGN=NEWSITE&');
            } else {
                redirUrl = redirUrl + '?CAMPAIGN=NEWSITE';
            }
            if (typeof split[1] === 'string') {
                if (window.location.href.indexOf('popin') !== -1) {
                    redirUrl += '#' + split[1];
                } else {
                    boolRedirect = false;
                }
            }
        }
        if (boolRedirect) {
            return redirUrl;
        }
    }
    return false;
}



// WEBPACK FOOTER //
// ./front/js/modules/seoLinks.js